import type { SyncBlockInstance } from '@atlaskit/editor-synced-block-provider';

export const syncedBlockLoadSSRData: () => Record<string, SyncBlockInstance> | undefined = () => {
	const rawSyncBlockData: SyncBlockInstance[] =
		typeof globalThis !== 'undefined'
			? (globalThis as any).__SSR_EDITOR_NODE_DATA_PROVIDERS_DATA__?.syncBlocks
			: undefined;

	if (rawSyncBlockData) {
		return rawSyncBlockData.reduce<Record<string, SyncBlockInstance>>((acc, item) => {
			acc[item.resourceId] = item;
			return acc;
		}, {});
	}

	return undefined;
};
